import _ from 'lodash'

import {
  UserIcon,
  UsersIcon,
  ClockIcon,
  ZapIcon,
  TruckIcon,
  InfoIcon,
  PlusIcon,
  TabletIcon,
} from 'vue-feather-icons'

export default {
  props: {
    cp: Object,
    cpu: Object,
    height: Number,
    width: Number,
    openedBoxId: String,
    forceHeight: Boolean,
    isSelected: Boolean,
    showIcons: Boolean,
    displayAssignButton: Boolean,
    clickFn: Function,
  },
  components: {
    UserIcon,
    UsersIcon,
    ClockIcon,
    ZapIcon,
    TruckIcon,
    InfoIcon,
    PlusIcon,
    TabletIcon,
  },
  data: function () {
    return {
      multiplayer: 1,
      calculatedWidth: 100, // default values
      calculatedHeight: 150, // default values
      parsedBoxes: [],
      borderWidthBonus: 2,
    }
  },
  watch: {
    cpu: {
      handler: function () {
        this.calculateMultiplayer()
        this.parseBoxes()
      },
      deep: true,
    },
  },
  mounted() {
    this.calculateMultiplayer()
    this.parseBoxes()
  },
  computed: {
    cpuStyle: function () {
      let styles = {}
      if (this.cp.operationKind == 'lockers') {
        const maxBoxesInRow = this.findMaxBoxesInRow(this.cpu.boxes).maxBoxesInRow
        const rowsCount = this.findMaxBoxesInRow(this.cpu.boxes).rowsCount
        const boxWidth = _.ceil(this.calculatedHeight / rowsCount, 2) // they are squares
        // console.log(maxBoxesInRow, rowsCount, boxWidth);

        styles = {
          width: `${maxBoxesInRow * boxWidth + this.borderWidthBonus}px`,
          height: `${this.calculatedHeight}px`,
          background: `${this.isSelected ? '#f0f9f8' : '#f5f5f5'}`,
          border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`,
        }
      } else {
        styles = {
          width: `${this.calculatedWidth}px`,
          height: `${this.calculatedHeight}px`,
          background: `${this.isSelected ? '#f0f9f8' : '#f5f5f5'}`,
          border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`,
        }
      }
      return styles
    },
  },

  methods: {
    calculateMultiplayer() {
      const isVertical = !this.cpu.height || this.cpu.width < this.cpu.height

      if (isVertical || this.forceHeight) {
        this.multiplayer = _.ceil(this.height / this.cpHeight(), 3) // manipulate this for details
        this.calculatedHeight = this.height + this.borderWidthBonus
        this.calculatedWidth = this.multiplayer * this.cpu.width + this.borderWidthBonus
      } else {
        this.multiplayer = _.ceil(this.width / this.cpWidth(), 3)
        this.calculatedHeight = this.multiplayer * this.cpu.height + this.borderWidthBonus
        this.calculatedWidth = this.width + this.borderWidthBonus
      }
    },

    cpHeight() {
      if (this.cp.dimensions) {
        return parseInt(this.cp.dimensions.split(',')[1])
      } else {
        return 0
      }
    },

    cpWidth() {
      if (this.cp.dimensions) {
        return parseInt(this.cp.dimensions.split(',')[0])
      } else {
        return 0
      }
    },

    parseBoxes() {
      const rawBoxes = this.cpu.boxes
      const cleanBoxes =
        this.cp.operationKind == 'lockers'
          ? this.cleanBoxesGeneratorLockers(rawBoxes)
          : this.cleanBoxesGenerator(rawBoxes)
      this.parsedBoxes = cleanBoxes
    },

    cleanBoxesGenerator(rawBoxes) {
      return rawBoxes
        .map(box => {
          if (box.coordinates) {
            const oldCoordinates = box.coordinates.split(',')
            const left = `${_.ceil(oldCoordinates[0] * this.multiplayer, 3)}px`
            const top = `${_.ceil(oldCoordinates[1] * this.multiplayer, 3)}px`
            const width = `${_.ceil(oldCoordinates[2] * this.multiplayer, 3)}px`
            const height = `${_.ceil(oldCoordinates[3] * this.multiplayer, 3)}px`
            const newCoordinates = { top, left, width, height }
            const newBox = Object.assign({}, box, { coordinates: newCoordinates })
            return newBox
          }

          // we must filter [undefined] out...
        })
        .filter(x => !!x && x.size != 'small')
    },

    cleanBoxesGeneratorLockers(rawBoxes) {
      const rowsCount = this.findMaxBoxesInRow(rawBoxes).rowsCount
      const cpuHeight = this.calculatedHeight
      const rowHeight = cpuHeight / rowsCount

      return rawBoxes
        .map(box => {
          const positions = box.position.split(',')
          if (!!box.position && this.hasProperPosition(positions)) {
            const row = positions[0]
            const orderFromLeft = positions[1]

            const left = `${_.ceil(row * rowHeight - rowHeight, 3)}px`
            const top = `${_.ceil(orderFromLeft * rowHeight - rowHeight, 3)}px`
            const width = `${_.ceil(rowHeight, 3)}px`
            const height = `${_.ceil(rowHeight, 3)}px`

            const newCoordinates = { top, left, width, height }
            const newBox = Object.assign({}, box, { coordinates: newCoordinates })
            return newBox
          }
        })
        .filter(x => !!x)
    },

    hasProperPosition(positions) {
      const left = parseFloat(positions[0])
      const top = parseFloat(positions[1])
      return (left == 0 && top >= 1) || (left >= 1 && top == 0) || (left >= 1 && top >= 1)
    },

    findMaxBoxesInRow: function (boxes) {
      const newBoxes = []

      boxes.forEach(box => {
        const positions = box.position.split(',')
        const left = parseFloat(positions[0])
        const top = parseFloat(positions[1])
        const newPositions = { top, left }
        const newBox = Object.assign({}, box, { coordinates: newPositions })

        if (this.hasProperPosition(positions)) {
          newBoxes.push(newBox)
        }
      })

      const rowsCount = Object.keys(_.groupBy(newBoxes, 'coordinates.top')).length
      const maxBoxesInRow = _.chain(newBoxes)
        .groupBy('coordinates.top') // {1: Array(4), 2: Array(4), 3: Array(4)}
        .toPairs() // [Array(2), Array(2), Array(2)]
        .map(value => value[1].length) // [4, 4, 4]
        .max() // 4
        .value()

      return {
        maxBoxesInRow,
        rowsCount,
      }
    },

    boxStyle: function (box) {
      let style = {}
      style = {
        top: box.coordinates.top,
        left: box.coordinates.left,
        width: box.coordinates.width,
        height: box.coordinates.height,
        border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`,
        background: `${box.id == this.openedBoxId ? '#67c9bb' : 'none'}`,
      }
      return style
    },
  },
}
